// utils/countries/index.ts
import countriesEN from './countriesEN.json';
import countriesES from './countriesES.json';
import phoneCountryCodes from './phoneCountryCode.json';

type CountryCode = keyof typeof countriesEN;
type LanguageCode = 'en' | 'es';

export type CountryOption = {
  code: CountryCode;
  name: string;
  dialCode: string;
  emoji: string;
}

export function getCountriesWithPhoneCodes(language: LanguageCode = 'es'): CountryOption[] {
  const countryNames = language === 'en' ? countriesEN : countriesES;
  
  return phoneCountryCodes
    .map(country => ({
      code: country.code as CountryCode,
      name: countryNames[country.code as CountryCode] || country.name,
      dialCode: country.dial_code,
      emoji: country.emoji
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
